// extracted by mini-css-extract-plugin
export default {"footerLinks":"FooterLinks_footerLinks__wCePw","footerLinksGroup":"FooterLinks_footerLinksGroup__zHxRa"};